import { htmlTemplateReview } from './htmlTemplateReview';

const htmlReviews = (elements, reviews, state) => {
  const { links } = elements;

  return reviews.map((review) => htmlTemplateReview({ ...review, links }, state)).join('');
};

const renderTotal = (elements, state) => {
  const { total: totalEl } = elements;
  const { total } = state;

  if (totalEl && total) {
    totalEl.textContent = total;
  }
};

export const renderReviews = (elements, reviews, state) => {
  const { wrapperReviews } = elements;

  wrapperReviews.innerHTML = '';
  wrapperReviews.insertAdjacentHTML('afterbegin', htmlReviews(elements, reviews, state));
  renderTotal(elements, state);
};
